import * as actionTypes from "../actions/actionTypes";

const initialState = {
	token: null,
	userId: null,
	error: null,
	refreshToken: null,
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.AUTH_INITIATE:
			return {
				...state,
				loading: true,
			};
		case actionTypes.AUTH_SUCCESS:
			return {
				...state,
				loading: false,
				token: action.token,
				uId: action.uId,
				refreshToken: action.refreshToken,
			};
		case actionTypes.AUTH_LOGOUT:
			return {
				...initialState,
			};
		default:
			return state;
	}
};

export default reducer;
